import { isBrowser } from '@patrianna/shared-utils/helpers'

export const REOPEN_PAYMENT_DIALOG_AFTER_DELETING_PAYMENT_METHOD = 'REOPEN_PAYMENT_DIALOG_AFTER_DELETING_PAYMENT_METHOD'
export const INTERNAL_GAME_NAVIGATION = 'internal_game_navigation'
export const SKIP_HOME_JACKPOT_FETCH_ONCE = 'SKIP_HOME_JACKPOT_FETCH_ONCE'
export const SNOWPLOW_PAYLOAD_KEY = 'snowplow_payload'
export const FRAUD_CHECK_COMPLETED = 'FRAUD_CHECK_COMPLETED'

const getSessionStorageSafe = (): Storage | null => {
  try {
    if (!isBrowser()) {
      return null
    }

    return window.sessionStorage
  } catch (err) {
    console.warn('[storage-safe] sessionStorage unavailable', err)

    return null
  }
}

export const setDataToSessionStorage = (key: string, value: object | string | boolean): void => {
  try {
    const storage = getSessionStorageSafe()

    if (storage) {
      storage.setItem(key, JSON.stringify(value))
    }
  } catch (err) {
    console.log(err)
  }
}

export const getDataFromSessionStorage = <T>(key: string): T | null => {
  try {
    const storage = getSessionStorageSafe()

    if (!storage) {
      return null
    }

    const data = storage.getItem(key)
    if (!data || data === 'undefined') {
      return null
    }
    const parsedData = JSON.parse(data) as T

    return parsedData as T
  } catch (err) {
    console.log(err)

    return null
  }
}

export const removeDataFromSessionStorage = (key: string): void => {
  try {
    const storage = getSessionStorageSafe()

    if (storage) {
      storage.removeItem(key)
    }
  } catch (err) {
    console.log(err)
  }
}

// Expose safe accessor for consumers that need raw Storage
export const getSafeSessionStorage = getSessionStorageSafe
